// ** React Imports
import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Grid,
  CircularProgress,
  Alert,
  IconButton,
  Chip,
  Divider,
  useTheme,
} from "@mui/material";
import {
  ArrowForward,
  ArrowBack,
  AddCircleOutline,
  MedicalServices,
  Assignment,
  Description,
  PersonAdd,
  CheckCircle,
  LocalHospital,
  Science,
} from "@mui/icons-material";
import ReactSelect from "react-select";
import { Controller, useForm } from "react-hook-form";
import AuthorizationFormByCPT from "../AuthorizationFormByCPT";
import Tmdform from "../Tmdform";
import AuthorizationRegistration from "../AuthorizationRegistration";

const NewAuthFromDashboard = (props) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [Charge, setCharge] = useState("");
  const [Charge1, setCharge1] = useState("");
  const [procedureCode1ID, setProcedureCode1ID] = useState("E0486");
  const [procedureCode1List, setProcedureCode1List] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAuthForm, setShowAuthForm] = useState(false);
  const [showTmdForm, setShowTmdForm] = useState(false);
  const [showIcdForm, setShowIcdForm] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);


  const handleClose = () => {
   props.handleCloseNewPriorAuth()

  };
  const [icdProps, setIcdProps] = useState({
    columnID: 0,
    Charge: "",
    Charge1: "",
    approvedcpt: "",
    patientId: 0,
    AutpattientIcd: 0,
    patientNametmd: "",
  });

  const { control, setValue, watch } = useForm();

  useEffect(() => {
    fetchProcedures();
  }, []);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const fetchProcedures = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Procedures/Procedures`,
        { headers },
      );
      const prac = response.map((field) => ({
        label: `${field.code} - ${field.description}`,
        value: field.code,
        qasim: field.code,
        charges: field.default_charges,
      }));
      setProcedureCode1List(prac);
    } catch (error) {
      console.error("Error fetching procedures:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleProcedureChange = (e) => {
    setSelectedProcedure(e);
    setProcedureCode1ID(e.value);
    setCharge(e.charges);
    setCharge1(e.qasim);
    setValue("procedureCode1", e.value);
    setActiveStep(1);
  };

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleOpenForm = () => {
    if (procedureCode1ID === "E0486") {
      setSelectedForm("authorization");
      setShowAuthForm(true);
      setShowTmdForm(false);
      setShowIcdForm(false);
    } else if (procedureCode1ID === "21085") {
      setSelectedForm("tmd");
      setShowTmdForm(true);
      setShowAuthForm(false);
      setShowIcdForm(false);
    } else {
      setSelectedForm("icd");
      setShowIcdForm(true);
      setShowAuthForm(false);
      setShowTmdForm(false);
    }
    setActiveStep(2);
  };

  const handleReset = () => {
    setActiveStep(0);
    setSelectedProcedure(null);
    setProcedureCode1ID("E0486");
    setShowAuthForm(false);
    setShowTmdForm(false);
    setShowIcdForm(false);
    setSelectedForm(null);
    setSelectedProcedure(null);
  };

  // Steps configuration
  const steps = [
    {
      label: "Select Procedure",
      description: "Choose the procedure code for authorization",
      icon: <MedicalServices />,
    },
    {
      label: "Review Selection",
      description: "Review your selected procedure",
      icon: <Assignment />,
    },
    {
      label: "Fill Authorization Form",
      description: "Complete the required information",
      icon: <Description />,
    },
  ];

  const getFormTitle = () => {
    if (selectedForm === "authorization") return "Authorization Registration";
    if (selectedForm === "tmd") return "TMD Form";
    if (selectedForm === "icd") return "ICD Authorization Form";
    return "Authorization Form";
  };

  const getFormIcon = () => {
    if (selectedForm === "authorization")
      return <Assignment sx={{ fontSize: 28 }} />;
    if (selectedForm === "tmd") return <Science sx={{ fontSize: 28 }} />;
    if (selectedForm === "icd") return <LocalHospital sx={{ fontSize: 28 }} />;
    return <Description sx={{ fontSize: 28 }} />;
  };

  return (
    <Box
      sx={{
        height: "100%",
        p: { xs: 1.5, sm: 2, md: 2 },
        overflow: "auto",
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f5f9",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#cbd5e1",
          borderRadius: "10px",
          "&:hover": {
            background: "#94a3b8",
          },
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: "24px",
          backgroundColor: "#ffffff",
          border: "1px solid rgba(0,0,0,0.04)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
          overflow: "hidden",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #1976d2, #42a5f5, #1976d2)",
            backgroundSize: "200% 100%",
            animation: "gradientMove 3s ease infinite",
          },
          "@keyframes gradientMove": {
            "0%": { backgroundPosition: "0% 0%" },
            "100%": { backgroundPosition: "200% 0%" },
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: { xs: 3, sm: 4 },
            py: { xs: 2.5, sm: 3 },
            borderBottom: "1px solid #f1f5f9",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #1976d2, #42a5f5)",
                borderRadius: "12px",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 14px rgba(25,118,210,0.25)",
              }}
            >
              <MedicalServices sx={{ color: "#fff", fontSize: "28px" }} />
            </Box>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: "#1a2332",
                  letterSpacing: "-0.02em",
                  fontSize: { xs: "1.1rem", sm: "1.3rem" },
                }}
              >
                New Authorization Request
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#6b7280",
                  fontSize: "0.8rem",
                }}
              >
                Follow the steps to complete the authorization process
              </Typography>
            </Box>
          </Box>

          {activeStep > 0 && (
            <Button
              variant="outlined"
              onClick={handleReset}
              startIcon={<ArrowBack />}
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.8rem",
                borderColor: "#e5e7eb",
                color: "#6b7280",
                "&:hover": {
                  borderColor: "#ef4444",
                  color: "#ef4444",
                  backgroundColor: "rgba(239,68,68,0.04)",
                },
              }}
            >
              Start Over
            </Button>
          )}
        </Box>

        {/* Stepper */}
        <Box sx={{ px: { xs: 3, sm: 4 }, pt: 4, pb: 2 }}>
          <Stepper
            activeStep={activeStep}
            orientation="vertical"
            sx={{
              "& .MuiStepConnector-line": {
                borderColor: "#e5e7eb",
              },
              "& .MuiStepLabel-label": {
                fontWeight: 600,
                color: "#1a2332",
                fontSize: "0.95rem",
              },
              "& .MuiStepLabel-label.Mui-active": {
                color: "#1976d2",
                fontWeight: 700,
              },
              "& .MuiStepIcon-root.Mui-active": {
                color: "#1976d2",
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: "#2e7d32",
              },
            }}
          >
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel
                  StepIconComponent={() => (
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor:
                          activeStep >= index ? "#1976d2" : "#e5e7eb",
                        color: activeStep >= index ? "#fff" : "#9ca3af",
                        transition: "all 0.3s ease",
                        fontSize: "18px",
                      }}
                    >
                      {activeStep > index ? (
                        <CheckCircle sx={{ fontSize: 20 }} />
                      ) : activeStep === index ? (
                        step.icon
                      ) : (
                        step.icon
                      )}
                    </Box>
                  )}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                      {step.label}
                    </Typography>
                    <Typography sx={{ color: "#6b7280", fontSize: "0.8rem" }}>
                      {step.description}
                    </Typography>
                  </Box>
                </StepLabel>

                <StepContent>
                  {index === 0 && (
                    <Box sx={{ pt: 2, pb: 1 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: "#374151",
                              mb: 1.5,
                              fontSize: "0.9rem",
                            }}
                          >
                            Select Procedure Code
                          </Typography>

                          {loading ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                py: 4,
                              }}
                            >
                              <CircularProgress
                                size={40}
                                sx={{ color: "#1976d2" }}
                              />
                              <Typography sx={{ ml: 2, color: "#6b7280" }}>
                                Loading procedures...
                              </Typography>
                            </Box>
                          ) : (
                            <>
                              <Controller
                                name="procedureCode1"
                                control={control}
                                render={({ field }) => (
                                  <ReactSelect
                                    {...field}
                                    placeholder="Search and select procedure code..."
                                    value={selectedProcedure}
                                    onChange={handleProcedureChange}
                                    options={procedureCode1List}
                                    styles={{
                                      container: (base) => ({
                                        ...base,
                                        width: "100%",
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        minHeight: 45,
                                        borderRadius: "12px",
                                        borderColor: "#e5e7eb",
                                        boxShadow: "none",
                                        "&:hover": {
                                          borderColor: "#1976d2",
                                        },
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected
                                          ? "#1976d2"
                                          : state.isFocused
                                            ? "#e3f2fd"
                                            : "transparent",
                                        color: state.isSelected
                                          ? "#fff"
                                          : "#1a2332",
                                        "&:active": {
                                          backgroundColor: "#1976d2",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />

                              {selectedProcedure && (
                                <Box
                                  sx={{
                                    mt: 2,
                                    p: 2,
                                    borderRadius: "12px",
                                    backgroundColor: "#f8fafc",
                                    border: "1px solid #e5e7eb",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    gap: 1,
                                  }}
                                >
                                  <Box>
                                    <Typography
                                      sx={{
                                        fontSize: "0.75rem",
                                        color: "#6b7280",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      Selected Procedure
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontWeight: 700,
                                        color: "#1a2332",
                                        fontSize: "0.95rem",
                                      }}
                                    >
                                      {selectedProcedure.label}
                                    </Typography>
                                  </Box>
                                  <Chip
                                    label={`Charges: $${selectedProcedure.charges || "N/A"}`}
                                    sx={{
                                      backgroundColor: "#e3f2fd",
                                      color: "#1976d2",
                                      fontWeight: 600,
                                      borderRadius: "8px",
                                    }}
                                  />
                                </Box>
                              )}
                            </>
                          )}
                        </Grid>
                      </Grid>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          mt: 3,
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={handleNext}
                          disabled={!selectedProcedure}
                          endIcon={<ArrowForward />}
                          sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            fontWeight: 600,
                            px: 4,
                            py: 1.2,
                            background:
                              "linear-gradient(135deg, #1976d2, #42a5f5)",
                            boxShadow: "0 4px 14px rgba(25,118,210,0.25)",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #1565c0, #1e88e5)",
                              boxShadow: "0 6px 20px rgba(25,118,210,0.35)",
                              transform: "translateY(-2px)",
                            },
                            "&:disabled": {
                              background: "#e5e7eb",
                              color: "#9ca3af",
                            },
                          }}
                        >
                          Next
                        </Button>
                      </Box>
                    </Box>
                  )}

                  {index === 1 && (
                    <Box sx={{ pt: 2, pb: 1 }}>
                      <Alert
                        severity="info"
                        sx={{
                          borderRadius: "12px",
                          mb: 3,
                          "& .MuiAlert-icon": {
                            color: "#1976d2",
                          },
                        }}
                      >
                        <Typography sx={{ fontWeight: 500 }}>
                          Please review your selection before proceeding
                        </Typography>
                      </Alert>

                      <Box
                        sx={{
                          p: 3,
                          borderRadius: "16px",
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e5e7eb",
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontSize: "0.75rem",
                                color: "#6b7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              Procedure Code
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: 700,
                                color: "#1a2332",
                                fontSize: "1.1rem",
                                mt: 0.5,
                              }}
                            >
                              {selectedProcedure?.value || "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontSize: "0.75rem",
                                color: "#6b7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              Description
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: 500,
                                color: "#374151",
                                fontSize: "0.95rem",
                                mt: 0.5,
                              }}
                            >
                              {selectedProcedure?.label || "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                          </Grid>
                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontSize: "0.75rem",
                                color: "#6b7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              Form to be filled
                            </Typography>
                            <Chip
                              icon={getFormIcon()}
                              label={getFormTitle()}
                              sx={{
                                mt: 0.5,
                                backgroundColor:
                                  procedureCode1ID === "E0486"
                                    ? "#e3f2fd"
                                    : procedureCode1ID === "21085"
                                      ? "#fce4ec"
                                      : "#f3e5f5",
                                color:
                                  procedureCode1ID === "E0486"
                                    ? "#1976d2"
                                    : procedureCode1ID === "21085"
                                      ? "#c62828"
                                      : "#6a1b9a",
                                fontWeight: 600,
                                borderRadius: "8px",
                                px: 2,
                                py: 1.5,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: 3,
                        }}
                      >
                        <Button
                          variant="outlined"
                          onClick={handleBack}
                          startIcon={<ArrowBack />}
                          sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            fontWeight: 600,
                            borderColor: "#e5e7eb",
                            color: "#6b7280",
                            px: 3,
                            "&:hover": {
                              borderColor: "#1976d2",
                              color: "#1976d2",
                              backgroundColor: "rgba(25,118,210,0.04)",
                            },
                          }}
                        >
                          Back
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleOpenForm}
                          endIcon={<AddCircleOutline />}
                          sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            fontWeight: 600,
                            px: 4,
                            py: 1.2,
                            background:
                              procedureCode1ID === "E0486"
                                ? "linear-gradient(135deg, #1976d2, #42a5f5)"
                                : procedureCode1ID === "21085"
                                  ? "linear-gradient(135deg, #c62828, #ef5350)"
                                  : "linear-gradient(135deg, #6a1b9a, #ab47bc)",
                            boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
                            },
                          }}
                        >
                          Proceed to Form
                        </Button>
                      </Box>
                    </Box>
                  )}

                  {index === 2 && (
                    <Box sx={{ pt: 2, pb: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          mb: 3,
                          pb: 2,
                          borderBottom: "1px solid #f1f5f9",
                        }}
                      >
                        <Box
                          sx={{
                            background:
                              procedureCode1ID === "E0486"
                                ? "linear-gradient(135deg, #1976d2, #42a5f5)"
                                : procedureCode1ID === "21085"
                                  ? "linear-gradient(135deg, #c62828, #ef5350)"
                                  : "linear-gradient(135deg, #6a1b9a, #ab47bc)",
                            borderRadius: "12px",
                            p: 1.2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                          }}
                        >
                          {getFormIcon()}
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              color: "#1a2332",
                              fontSize: "1.1rem",
                            }}
                          >
                            {getFormTitle()}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#6b7280",
                              fontSize: "0.8rem",
                            }}
                          >
                            Complete the form below to submit authorization
                          </Typography>
                        </Box>
                      </Box>

                      {/* Render Forms */}
                      {showAuthForm && (
                        <AuthorizationRegistration
                          columnID={0}
                          setAuthId={0}
                          AutpattientID={0}
                          patientName={''}
                          Charge1={Charge1}
                          patientId={0}
                          CloseModal={handleClose}
                        />
                      )}

                      {showTmdForm && (
                        <Tmdform
                  PatientdateTMD={""}
                  callingFrom={"Patient"}
                  columnID={0}
                  patientId={0}
                  AutpattientID={0}
                  patientNametmd={''}
                  CloseModal={handleClose}
                        />
                      )}

                      {showIcdForm && (
                        <AuthorizationFormByCPT
                       columnID={0}
                        Charge={Charge}
                        Charge1={Charge1}
                        patientId={0}
                        AutpattientIcd={0}
                        patientNametmd={''}
                        CloseModal={handleClose}
                        />
                      )}
                    </Box>
                  )}
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            px: { xs: 3, sm: 4 },
            py: 2,
            borderTop: "1px solid #f1f5f9",
            backgroundColor: "#fafcff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.75rem",
              color: "#9ca3af",
            }}
          >
            {activeStep === 0 && "Step 1 of 3: Select procedure code"}
            {activeStep === 1 && "Step 2 of 3: Review and confirm"}
            {activeStep === 2 && "Step 3 of 3: Complete authorization form"}
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            {[0, 1, 2].map((step) => (
              <Box
                key={step}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: activeStep === step ? "#1976d2" : "#e5e7eb",
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default NewAuthFromDashboard;
